import React, { createContext, useContext, useState, useCallback } from 'react';
import { useFormInstanceSelect } from './FormInstance.service';
import { ToastItem } from '../ToastItem';
// Create the context with a default value
const FormContext = createContext(null);
const ToastContext = createContext(null);
// Provider component that wraps the form and makes the configService available to any child component
export const FormProvider = ({ formInstance, children }) => {
    const [toasts, setToasts] = useState([]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);
    const addToast = useCallback((message, type = 'info', actionButton, onDismiss) => {
        const id = `toast-${Date.now()}-${Math.random()}`;
        const newToast = {
            id,
            message,
            type,
            actionButton,
            onDismiss,
        };
        setToasts((prev) => [...prev, newToast]);
    }, [removeToast]);
    const toastContextValue = {
        toasts,
        addToast,
        removeToast,
    };
    return (React.createElement(FormContext.Provider, { value: formInstance },
        React.createElement(ToastContext.Provider, { value: toastContextValue },
            children,
            React.createElement(ToastContainer, null))));
};
// Custom hook to use the configService
export const useFluidForm = () => {
    const context = useContext(FormContext);
    let form = useFormInstanceSelect((state) => state.fluidForm);
    if (context === null) {
        throw new Error('useConfigService must be used within a FormProvider');
    }
    return form;
};
export const useFormInstance = () => {
    return useContext(FormContext);
};
// Toast hook - available within FormProvider
export const useFormToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useFormToast must be used within a FormProvider');
    }
    return context;
};
const ToastContainer = () => {
    const { toasts, removeToast } = useFormToast();
    if (toasts.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "toast-container" }, toasts.map((toast) => (React.createElement(ToastItem, { key: toast.id, toast: toast, onDismiss: (toastId) => {
            toast.onDismiss?.();
            removeToast(toastId);
        } })))));
};
